import Select from 'react-select';
import styles from './styles.module.scss';
import { Box, Button } from '@mui/material';
import { TfiArrowCircleLeft, TfiArrowCircleRight } from 'react-icons/tfi';
import { CustomOption } from 'components/reactSelect/customOption';
import { countItems } from 'configs/data';
import { MdKeyboardArrowDown } from 'react-icons/md';

type FooterProps = {
  data?: any;
  limit?: string;
  setPage?: any;
  selectHiddin?: boolean;
  setLimit?: (e: string) => void;
};

type FooterProps2 = {
  data?: any;
  setPage?: any;
  page?: number;
};

type GlobalProps = {
  data?: any;
  setPage?: any;
  page?: number;
  limit?: string;
  customSize?: boolean;
  selectHiddin?: boolean;
  setLimit?: (e: string) => void;
};

export function CustomPagination2({
  data,
  limit,
  setLimit,
  setPage,
  selectHiddin = true,
}: FooterProps) {
  const colourStyles = {
    control: (provided: any) => ({
      ...provided,
      width: '80px',
      minHeight: '30px !important',
      cursor: 'pointer',
      border: '1px solid #C4c4c4',
      background: 'transparent',
      textAlign: 'center',
    }),
  };

  return (
    <div className={styles.paginateLeft}>
      <span className={styles.text}>Отображено:</span>
      <span className={styles.paginationCount}>1</span>
      <span>-</span>
      <span className={styles.paginationCount}>{data?.results?.length || ` ${0}`}</span>
      <span className={styles.paginationCount}>из</span>
      <span className={styles.paginationCount}>{data?.total || ` ${0}`}</span>

      <Box ml='20px' display={!selectHiddin ? 'none' : 'block'}>
        <Select
          placeholder=''
          defaultValue={{
            label: String(limit),
            value: limit,
          }}
          isSearchable={false}
          menuPosition='fixed'
          options={countItems}
          styles={colourStyles}
          onChange={(e: any) => {
            setLimit?.(e.value);
            setPage(1);
          }}
          components={{
            Option: CustomOption,
            IndicatorSeparator: () => null,
            IndicatorsContainer: () => <MdKeyboardArrowDown style={{ marginRight: '5px' }} />,
          }}
        />
      </Box>
    </div>
  );
}

export function CustomPagination3({ data, setPage, page }: FooterProps2) {
  return (
    <div className={styles.paginationRight}>
      <Button
        id='prev'
        aria-label='prev'
        sx={{
          cursor: data?.current_page === 1 ? 'not-allowed' : 'pointer',
        }}
        onClick={() => data?.current_page !== 1 && setPage((prev: number) => prev - 1)}
        className={styles.button}>
        <TfiArrowCircleLeft size={24} />
      </Button>
      <span className={styles.text}>Страница:</span>
      <span className={styles.paginationCount}>{page || 1} из</span>
      <span className={styles.paginationCount}>{data?.total_pages || ` ${0}`}</span>
      <Button
        id='next'
        aria-label='next'
        onClick={() =>
          data?.current_page !== data?.total_pages ? setPage((prew: number) => prew + 1) : null
        }
        className={styles.button}
        sx={{
          cursor: data?.current_page === data?.total_pages ? 'not-allowed' : 'pointer',
        }}>
        <TfiArrowCircleRight size={24} />
      </Button>
    </div>
  );
}

export function CustomFooter({
  data,
  setPage,
  page,
  limit,
  setLimit,
  customSize = false,
  selectHiddin = true,
}: GlobalProps) {
  return (
    <Box
      justifyContent={customSize ? 'center !important' : 'space-between !important'}
      className={styles.container}>
      <CustomPagination2
        data={data}
        limit={limit}
        setPage={setPage}
        setLimit={setLimit}
        selectHiddin={selectHiddin}
      />
      <CustomPagination3 data={data} setPage={setPage} page={page} />
    </Box>
  );
}
